subscription MigrationUpdatedSubscription($id: ID!) {
  migrationUpdated(id: $id) {
    id
    title
    status
    error
    attemptsMade
    lastRunAt
    createdAt
  }
}
